import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-switch-card',
  templateUrl: './switch-card.component.html',
  styleUrls: ['./switch-card.component.scss'],
})
export class SwitchCardComponent {
  @Input() label: string;
  @Input() allowChanges: boolean;
  @Input() enabled: boolean;
  @Input() message: any;
  @Output() action = new EventEmitter<any>();

  handleToggle(enabled: boolean) {
    this.enabled = enabled;
    const payload = { enabled, message: this.message };
    this.emitAction(payload);
  }

  handleChangeMessage(event: any) {
    const payload = { enabled: this.enabled, message: this.message };
    this.emitAction(payload);
  }

  emitAction(payload: any) {
    this.allowChanges && this.action.emit(payload);
  }
}
